module.exports = __webpack_public_path__ + "img/d11cc9e.jpg";